import {
  ADD_NEW_QUOTE,
  AddNewQuoteAction,
  CREATE_NEW_FOLDER_FOR_AD,
  CreateNewFolderForAdOnDAM,
  DELETE_NOTICE_REQUEST,
  DELETE_QUOTE_ROW,
  DELETE_UPLOADED_FILE,
  DELETE_UPLOADED_FILE_REDUCER,
  DeleteNoticeRequestAction,
  DeleteQuoteRowAction,
  DeleteUploadedFile,
  DeleteUploadedFileReducer,
  FETCH_ALL_RAISE_AD_REQUEST,
  FetchAllRaiseAdRequestAction,
  GET_AGENCY_QUOTES_DATA,
  GET_ALL_RAISE_REQUEST,
  GET_CITIES,
  GET_FILES_BY_STAGE,
  GET_NOTICE_EMAIL_DATA,
  GET_QUOTATION_DATA,
  GET_USER_WORKSPACE_ROLE,
  GetAgencyQuotesFormDataAction,
  GetAllRaisedRequestAction,
  GetAllRaisedRequestType,
  GetCitiesByStateAction,
  GetFilesByStageAction,
  GetNoticeEmailDataAction,
  GetQuotationDataAction,
  GetUserWorkspaceRoleAction,
  PATCH_AGENCY_QUOTES,
  PatchAgencyQuotesAction,
  POST_QUOTATION_DATA,
  PostQuotationDataAction,
  QuoationApprovalFormDataType,
  QuotationDetailsType,
  QuotationFormDataType,
  RAISE_NEW_AD_REQUEST,
  RaisedRequestType,
  RaiseNewRequestAction,
  RESET_QUOTATION_DATA,
  ResetQuoationApprovalFormData,
  SAVE_QUOTE_FORM_DATA,
  SaveQuoteFormDataAction,
  SEND_EMAIL,
  SendEmailAction,
  SET_AGENCY_QUOTES_DATA,
  SET_AGENCY_QUOTES_ROW_DATA,
  SET_CITIES,
  SET_EMAIL_DATA,
  SET_NEW_QUOTE_ROW,
  SET_QUOTATION_DATA,
  SET_REQUEST_ID,
  SET_UPLOADED_FILE,
  SET_UPLOADED_FILE_FOR_AD_AGENCY,
  SET_USER_WORKSPACE_ROLE,
  SetAgencyQuotesFormDataAction,
  SetAgencyQuotesRowData,
  SetCitiesByStateAction,
  SetEmailDataAction,
  SetNewQuoteRow,
  SetQuotationDataAction,
  SetRequestId,
  SetUploadedFile,
  SetUploadedFileForAdAgency,
  SetUserWorkspaceRoleAction,
  START_REQUEST_LOADING,
  StartRequestLoadingAction,
  StatesCitiesType,
  STOP_REQUEST_LOADING,
  StopRequestLoadingAction,
  UPADTE_AGENCY_QUOTES,
  UPDATE_LAST_STEP_KEY,
  UpdatehAgencyQuotesAction,
  UpdateLastStepKey,
  UPLOAD_FILE_LOADER_ACTION,
  UPLOAD_REQUEST_FILE,
  UploadedFileType,
  UploadingFileLoaderAction,
  UploadRequestFile,
} from "../types/raiseAdRequest";

export const fetchAllRaiseAdRequest = (payload: {
  productId: string;
  page?: number | string;
  search?: string;
}): FetchAllRaiseAdRequestAction => ({
  type: FETCH_ALL_RAISE_AD_REQUEST,
  payload,
});

export const getAllRaisedRequest = (payload: {
  data: any;
  page: string | number;
  search?: string;
}): GetAllRaisedRequestAction => ({
  type: GET_ALL_RAISE_REQUEST,
  payload,
});

export const raiseNewRequestAction = (
  productId: string
): RaiseNewRequestAction => ({
  type: RAISE_NEW_AD_REQUEST,
  payload: productId,
});

export const getQuotationDataAction = (
  productId: string
): GetQuotationDataAction => ({
  type: GET_QUOTATION_DATA,
  payload: productId,
});

export const setQuotationDataAction = (payload: {
  quotationData: QuoationApprovalFormDataType;
  states: StatesCitiesType[];
}): SetQuotationDataAction => ({
  type: SET_QUOTATION_DATA,
  payload,
});

export const postQuotationDataAction = (payload: {
  id: number | string;
  formData: any;
  stage: string;
  nextStepKey: string;
  workspaceId: string;
  emailFormValues?: any;
}): PostQuotationDataAction => ({
  type: POST_QUOTATION_DATA,
  payload,
});

export const updateLastStepKey = (lastStepKey: string): UpdateLastStepKey => ({
  type: UPDATE_LAST_STEP_KEY,
  payload: lastStepKey,
});

export const getAgencyQuotesFormDataAction = (
  requestId: string
): GetAgencyQuotesFormDataAction => ({
  type: GET_AGENCY_QUOTES_DATA,
  payload: requestId,
});

export const setAgencyQuotesFormDataAction = (
  data: any
): SetAgencyQuotesFormDataAction => ({
  type: SET_AGENCY_QUOTES_DATA,
  payload: data,
});

export const addNewQuoteAction = (request: string): AddNewQuoteAction => ({
  type: ADD_NEW_QUOTE,
  payload: request,
});

export const getCitiesByStateAction = (
  stateId: number
): GetCitiesByStateAction => ({
  type: GET_CITIES,
  payload: stateId,
});

export const saveQuoteFormDataAction = (
  formData: any
): SaveQuoteFormDataAction => ({
  type: SAVE_QUOTE_FORM_DATA,
  payload: formData,
});

export const setCitiesByStateAction = (
  cities: StatesCitiesType[]
): SetCitiesByStateAction => ({
  type: SET_CITIES,
  payload: cities,
});

export const deleteQuoteRowAction = (rowId: Number): DeleteQuoteRowAction => ({
  type: DELETE_QUOTE_ROW,
  payload: rowId,
});

export const setNewQuoteRow = (
  data: QuotationFormDataType
): SetNewQuoteRow => ({
  type: SET_NEW_QUOTE_ROW,
  payload: data,
});

export const setAgencyQuotesRowData = (payload: {
  identifier: string | number;
  field: string;
  value: string | number;
}): SetAgencyQuotesRowData => ({
  type: SET_AGENCY_QUOTES_ROW_DATA,
  payload,
});

export const patchAgencyQuotesAction = (payload: {
  status: string;
  stage: string;
  nextStepKey?: string;
  workspaceId?: string;
  id?: number | string;
  folder_url?: string;
  emailContent?: any;
  shouldSendMail?: boolean;
  tableHtml?: any;
}): PatchAgencyQuotesAction => ({
  type: PATCH_AGENCY_QUOTES,
  payload,
});

export const updatehAgencyQuotesAction = (payload: {
  quotes_data: QuotationFormDataType[];
  status: string;
  stage: string;
}): UpdatehAgencyQuotesAction => ({
  type: UPADTE_AGENCY_QUOTES,
  payload,
});

export const getNoticeEmailDataAction = (payload: {
  requestId: string | number;
  stage: number;
}): GetNoticeEmailDataAction => ({
  type: GET_NOTICE_EMAIL_DATA,
  payload,
});

export const createNewFolderForAdOnDAM = (payload: {
  name: string;
  product_id: string;
  requestId: string;
  shouldSendMail: boolean;
  emailContent: any;
  tableHtml: any;
}): CreateNewFolderForAdOnDAM => ({
  type: CREATE_NEW_FOLDER_FOR_AD,
  payload,
});

export const deleteNoticeRequestAction = (payload: {
  selectedProductId: string;
  requestId: string;
}): DeleteNoticeRequestAction => ({
  type: DELETE_NOTICE_REQUEST,
  payload,
});

export const getFilesByStageAction = (payload: {
  request_id: string;
  stage: string;
}): GetFilesByStageAction => ({
  type: GET_FILES_BY_STAGE,
  payload,
});

export const uploadRequestFile = (
  payload: {
    request_id: string;
    stage: string;
    file: string;
    original_filename: string;
    title: string;
    file_size: number;
    file_type: string;
    file_category: string;
    next_stage: string;
    selectedProductId: string;
    release_date?: string;
  },
  callback: Function
): UploadRequestFile => ({
  type: UPLOAD_REQUEST_FILE,
  payload,
  callback,
});

export const setUploadedFileForAdAgency = (payload: {
  data: UploadedFileType[];
  stage: string;
}): SetUploadedFileForAdAgency => ({
  type: SET_UPLOADED_FILE_FOR_AD_AGENCY,
  payload,
});

export const deleteUploadedFile = (payload: {
  id: number;
  stage: string;
}): DeleteUploadedFile => ({
  type: DELETE_UPLOADED_FILE,
  payload,
});

export const deleteUploadedFileReducer = (payload: {
  id: number;
  stage: string;
}): DeleteUploadedFileReducer => ({
  type: DELETE_UPLOADED_FILE_REDUCER,
  payload,
});

export const setEmailDataAction = (payload: {
  data: any;
  stage: number;
}): SetEmailDataAction => ({
  type: SET_EMAIL_DATA,
  payload,
});

export const setRequestId = (payload: {
  requestId: string;
  selectedProductId: string;
}): SetRequestId => ({
  type: SET_REQUEST_ID,
  payload,
});

export const sendEmailAction = (payload: {
  formData: any;
  template_id: string;
  stage: string;
  emailFormValues?: any;
  s3_urls?: string[];
  tableHtml?: any;
}): SendEmailAction => ({
  type: SEND_EMAIL,
  payload,
});

export const getUserWorkspaceRoleAction = (
  workspaceId: string
): GetUserWorkspaceRoleAction => ({
  type: GET_USER_WORKSPACE_ROLE,
  payload: workspaceId,
});

export const setUserWorkspaceRoleAction = (
  userRole: string
): SetUserWorkspaceRoleAction => ({
  type: SET_USER_WORKSPACE_ROLE,
  payload: userRole,
});

export const stopLoadingOnErrorAction = (): StopRequestLoadingAction => ({
  type: STOP_REQUEST_LOADING,
});

export const startRequestLoadingAction = (): StartRequestLoadingAction => ({
  type: START_REQUEST_LOADING,
});

export const uploadingFileLoaderAction = (
  isLoading: boolean
): UploadingFileLoaderAction => ({
  type: UPLOAD_FILE_LOADER_ACTION,
  payload: isLoading,
});

export const setUploadedFile = (data: any): SetUploadedFile => ({
  type: SET_UPLOADED_FILE,
  payload: data,
});

export const resetQuoationApprovalFormData = (
  shouldReset: boolean
): ResetQuoationApprovalFormData => ({
  type: RESET_QUOTATION_DATA,
  payload: shouldReset,
});
